<template>
    <div class="sidebar-account">
        <b-img
          :src="avatar"
          @error="$event.target.src = defaultAvatar"
          rounded="circle"
          alt="Аккаунт"
          fluid
        />
        <p class="account-name lead mb-0">{{ name }}</p>

        <p class="account-role text-muted mb-0">{{ role }}</p>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import UserMixin from '@/components/helpers/mixins/user-mixin'

export default {
  name: 'SidebarAccount',
  data() {
    return {
      defaultAvatar: '/images/account/default.jpg'
    }
  },
  mixins: [UserMixin],
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser'
    }),
    avatar() {
      return this.hasUser && this.currUser.avatarFile ? `/api/files/${this.currUser.avatarFile.physicalName}` : this.defaultAvatar
    },
    name() {
      return this.hasUser ? `${this.currUser.name} ${this.currUser.surname}` : ''
    },
    role() {
      if (this.hasUser) {
        let stringRoles = ''
        let role = ''
        for (let i = 0; i < this.currUser.roles.length - 1; i++) {
          role = this.$_userMixin_roleTranslate(this.currUser.roles[i].title)
          stringRoles += `${role}, `
        }
        role = this.$_userMixin_roleTranslate(this.currUser
          .roles[this.currUser.roles.length - 1].title)
        stringRoles += role
        return stringRoles
      }
      return ''
    },
    hasUser() {
      return Object.keys(this.currUser).length
    }
  }
}
</script>

<style scoped>
    .account-name {
        line-height: 2;
        word-break: break-all;
    }
</style>
